import { RHFTextField, type RHFTextFieldProps } from '@/components/form-controls';

import type { LinksFormFieldName } from '../LinksForm';

type LinkFieldProps = RHFTextFieldProps & {
  name: LinksFormFieldName;
  onClearField?: (fieldName: LinksFormFieldName) => void;
};

export const LinkField = (props: LinkFieldProps) => {
  const { name, onClearField, ...restTextFieldProps } = props;

  const handleClear = (name: LinksFormFieldName) => {
    onClearField?.(name);
  };

  return (
    <RHFTextField
      fullWidth
      name={name}
      id={name}
      variant="filled"
      onClear={() => handleClear(name)}
      {...restTextFieldProps}
    />
  );
};
